/**
 * Firestore comments/replies are written by several different code paths
 * (callable functions, direct client writes, legacy migrations) and each
 * path stamps the record with a slightly different id field. These helpers
 * centralize the fallback chain so every caller picks the same canonical id.
 *
 * Returns the first truthy id-like property or `null`.
 */
export const getCommentRecordId = (comment) =>
  comment?.id ||
  comment?.commentId ||
  comment?.commentID ||
  comment?.comment_id ||
  comment?.legacyId ||
  comment?.firebaseId ||
  null;

export const getReplyRecordId = (reply) =>
  reply?.id ||
  reply?.replyId ||
  reply?.replyID ||
  reply?.reply_id ||
  reply?.legacyId ||
  reply?.firebaseId ||
  null;
